export default "__VITE_ASSET__e18c1ab7__"